const query = (id, isPreview) => `
{
    documentsList(id: "${id}", preview: ${isPreview}) {
        heading
        brandsListCollection(limit:20) {
      items {
        ... on BrandDocumentList {
          brandName
          mainDocumentsListCollection {
            items {
              ... on SubDocumentList {
                mainDocumentWithLabel {
                  ... on Link {
                    url
                    label
                  }
                }
                subDoumentsListWithLabelCollection(limit:3) {
                  items {
                    ... on Link {
                      url
                      label
                    }
                  }
                }
                publishDate
              }
            }
          }
        }
      }
    }
    }
}`

module.exports = { query }
